import { Typegroup_service } from "../services/Typegroup.service"
import { Operator_service } from "../services/Operator_service"
import { Report_promotion_service } from "../services/Report_promotion_service"
import moment from "moment";
import { Loading } from 'element-ui'
const month_th = [
    "มกราคม ",
    "กุมภาพันธ์ ",
    "มีนาคม ",
    "เมษายน ",
    "พฤษภาคม ",
    "มิถุนายน ",
    "กรกฎาคม ",
    "สิงหาคม ",
    "กันยายน ",
    "ตุลาคม ",
    "พฤศจิกายน ",
    "ธันวาคม "
  ]
const month_short_th = [
    "ม.ค.-",
    "ก.พ.-",
    "มี.ค.-",
    "เม.ย.-",
    "พ.ค.-",
    "มิ.ย.-",
    "ก.ค.-",
    "ส.ค.-",
    "ก.ย.-",
    "ต.ค.-",
    "พ.ย.-",
    "ธ.ค.-"
  ]
import { MessageBox } from 'element-ui'
const state = {
    current_chart: '',
    provider_group : [],
    provider_list : [],
    charts : {},
    prototype : {
        pie: {
            chart: {
                type: 'pie'
            },
            title: {
                text: ''
            },
            series: [{
                name: 'จำนวนรายการส่งเสริมการขาย',
                colorByPoint: true,
                data: [{
                    name: 'Prepaid',
                    y: 41.41,
                    sliced: false,
                    selected: false
                }, {
                    name: 'Postpaid',
                    y: 17.71
                }, {
                    name: 'On-top',
                    y: 40.89
                }],
                showInLegend: true,
                allowPointSelect: true
            }],
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        distance : -50,
                        format: '<b>{point.name}</b> <br> {point.percentage:.2f} %'
                    },
                    showInLegend: true
                }
            },
            legend: {},
            yAxis: {
                title: ''
            },
            credits: {
                enabled: false
            },
            responsive: {
                rules: [{
                    condition: {
                        minWidth: 2560
                    },
                    chartOptions: {
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: true,
                                    distance : -100,
                                    format: '<b>{point.name}</b> <br> {point.percentage:.2f} %',
                                    style: {
                                        fontSize: '24px'
                                    }
                                },
                                showInLegend: true,
                                size: 500
                            }
                        },
                        title: {
                            style: {
                                fontSize: '25px'
                            }
                        },
                        legend: {
                            itemStyle: {
                                fontSize: '20px'
                            }
                        }
                    }
                }]
            },
            exporting: {
                chartOptions: {
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: true,
                                distance : -50,
                                format: '<b>{point.name}</b> <br> {point.percentage:.2f} %',
                                style: {
                                    fontSize: '11px'
                                }
                            },
                            // size: 272
                            size: 220
                        }
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    legend: {
                        itemStyle: {
                            fontSize: '11px'
                        }
                    }
                },
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
                    }
                }
            }
        },
        postpaid : {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Postpaid',
                margin: 50
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true,
                title: "ผู้ให้บริการ"
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'จำนวนรายการส่งเสริมการขาย',
                    align: 'high',
                    offset: -100,
                    rotation: 0,
                    y: -30
                }
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.y}</b> <br/><br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        overflow: "allow",
                        crop: false
                    }
                }
            },
            series: [],
            legend: {},
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    title: {
                        style: {
                            fontSize: '14px'
                        }
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        prepaid : {
            chart: {
                type: 'column'
            },
            title: {
                text: 'Prepaid',
                margin: 50
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'จำนวนรายการส่งเสริมการขาย',
                    align: 'high',
                    offset: -100,
                    rotation: 0,
                    y: -30
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        overflow: "allow",
                        crop: false
                    }
                }
            },
            series: [],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    title: {
                        style: {
                            fontSize: '14px'
                        }
                    }
                }
            },
            credits: {
                enabled: false
            }
        },
        ontop : {
            chart: {
                type: 'column'
            },
            title: {
                text: 'On-top',
                margin: 50
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: [],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'จำนวนรายการส่งเสริมการขาย',
                    align: 'high',
                    offset: -100,
                    rotation: 0,
                    y: -30
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.0f}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        overflow: "allow",
                        crop: false
                    }
                }
            },
            series: [],
            exporting: {
                buttons: {
                    contextButton:{
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    title: {
                        style: {
                            fontSize: '14px'
                        }
                    }
                }
            },
            credits: {
                enabled: false
            }
        }
    },
    displayCharts: false,
    displayText: false
}
const actions = {

    async initChart({commit}){
        state.displayCharts = false
        state.displayText = false
        commit('RESET_CHART')
    },
    
    async getGroupCompany({commit},type){
        let obj = { provider_type : type}
        let result = await Typegroup_service.getGroupList(obj)
        if(result.status === 200){
            commit('PROVIDER_GROUP',result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
             })
        }
    },

    async getProviderByType({commit},type){
        let result = await Operator_service.getProviderList(type)
        if(result.status === 200){
            commit('PROVIDER_LIST',result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },

    async setChartData({commit},formdata){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('RESET_CHART')
        if(formdata.compare_type == 'group'){
            formdata.provider_title = formdata.list.length == 1 ? "ของกลุ่มผู้ให้บริการ " + formdata.list[0].group_name_th : ""
        }else{
            formdata.provider_title = formdata.list.length == 1 ? "ของผู้ให้บริการ " + formdata.list[0].brand_name : ""
        } 
        let date = {
            start: null,
            end: null
        }
        let start = null
        let end = null
        let oldData = null
        let result = null
        switch (formdata.type_report) {
            case 'month' :
                start = moment(formdata.type_data.month).format('YYYY-MM-DD')
                end = moment(formdata.type_data.month).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                break
            case 'between_month' :
                start = moment(formdata.type_data.monthfrom).format('YYYY-MM-DD')
                end = moment(formdata.type_data.monthto).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                break
            case 'year' :
                start = moment(formdata.type_data.year).format('YYYY-MM-DD')
                end = moment(start).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
                break
            case 'between_year' :
                start = moment(formdata.type_data.yearfrom).format('YYYY-MM-DD')
                end = moment(formdata.type_data.yearto).add(1, 'Y').subtract(1, 'd').format('YYYY-MM-DD')
                break
            case 'quarter' :
                start = moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter-1) * 3, 'M').format('YYYY-MM-DD')
                end = moment(start).add(3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                break
            case 'between_quarter' :
                start = moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom-1) * 3, 'M').format('YYYY-MM-DD')
                end = moment(formdata.type_data.quarter_year).add((formdata.type_data.quarterto) * 3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
                break
        }
        date = {
            start: start,
            end: end
        }
        formdata.date = date
        let countData = []
        if(((moment(date.start).year() < 2020) && (moment(date.start).year() > 2013)) || ((moment(date.end).year() < 2020) && (moment(date.end).year() > 2013)) || ((moment(date.end).year() >= 2020) && (moment(date.start).year() <= 2013)) ){
            oldData = await Report_promotion_service.getCountFixedMobile(formdata)
            if(oldData.data.length != 0 ){
                countData = countData.concat(oldData.data)
            }
        }
        if(moment(date.end).year() >= 2020){
            result = await Report_promotion_service.getMobilePromotions(formdata)
            countData = countData.concat(result.data)
        }
        if(countData.length == 0) {
            setTimeout(function(){ loadingInstance.close() }, 250);
            commit('DISPLAY_CHART',false)
        }else{
            commit('DISPLAY_CHART',true)
            let obj_date = {
                start: moment(date.start)._d,
                end: moment(date.end)._d
            }
            let obj = {
                forminfo: formdata,
                qrydata: countData,
                date: obj_date
            }
            switch (formdata.type_report){
                case 'month' :
                    commit('MONTH',obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                case 'between_month' :
                    commit('BETWEEN_MONTH',obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                case 'year' :
                    commit('YEAR',obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                case 'between_year' :
                    commit('BETWEEN_YEAR',obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                case 'quarter' :
                    commit('QUARTER', obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                case 'between_quarter' :
                    commit('BETWEEN_QUARTER',obj)
                    setTimeout(function(){ loadingInstance.close() }, 250);
                    break
                }
            }
        }
    };

const mutations = {
    RESET_CHART(state){
        state.charts = []
    },
    PROVIDER_GROUP(state,data){
        state.provider_group = data
    },
    PROVIDER_LIST(state,data){
        state.provider_list = data
    },
  
    MONTH(state,obj){
        let date = obj.forminfo.type_data.month
        let month = parseInt(moment(new Date(date)).format("MM"))
        let year = parseInt(moment(new Date(date)).format("YYYY"))+543
        let list = obj.forminfo.list
        let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        pie_obj.title.text = "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่" + obj.forminfo.provider_title + " เดือน" + month_th[month-1] + " ปี พ.ศ. " + year
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) เดือน"+month_th[month-1]+" ปี พ.ศ. "+year
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) เดือน"+month_th[month-1]+" ปี พ.ศ. "+year
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) เดือน"+month_th[month-1]+" ปี พ.ศ. "+year
        pie_obj.series = []
        let short_month = month_short_th[month - 1] + (parseInt(year)-2500)
        postpaid_obj.series.push({
            name: short_month,
            color: '',
            data: []
        })
        prepaid_obj.series.push({
            name: short_month,
            color: '',
            data: []
        })
        ontop_obj.series.push({
            name: short_month,
            color: '',
            data: []
        })
        let total =  {
            prepaid : 0,
            postpaid : 0,
            ontop : 0
        }
        for(let x = 0 ; x < list.length ; x++){
            let name = obj.forminfo.compare_type == 'group' ? list[x].group_name_th : list[x].brand_name
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            let rowdata = obj.qrydata.filter(item => provider_id.includes(item.provider_id))
            let prepaid = 0,
            postpaid = 0,
            ontop = 0
            for(let a = 0; a < rowdata.length; a++){
                if(moment(rowdata[a].monthly_regulate).year() < 2020){
                    postpaid += rowdata[a].postpaid
                    prepaid += rowdata[a].prepaid
                    ontop += rowdata[a].ontop
                    total.postpaid += rowdata[a].postpaid
                    total.prepaid += rowdata[a].prepaid
                    total.ontop += rowdata[a].ontop
                }else{
                    if(rowdata[a].promotion_type == 'main'){
                        if(rowdata[a].promotion_category == 'prepaid'){
                            prepaid += rowdata[a].amount
                            total.prepaid += rowdata[a].amount
                        }else{//postpaid
                            postpaid += rowdata[a].amount
                            total.postpaid += rowdata[a].amount
                        }
                    }else{//ontop
                        ontop += rowdata[a].amount
                        total.ontop += rowdata[a].amount
                    }   
                }
            }
            if(obj.forminfo.chart_type == 'column') {
                postpaid_obj.xAxis.categories.push(name)
                prepaid_obj.xAxis.categories.push(name)
                ontop_obj.xAxis.categories.push(name)
                postpaid_obj.series[0].data.push(postpaid != 0 ? postpaid : null)
                postpaid_obj.series[0].color = 'rgba(235,200,0,1)'
                postpaid_obj.series[0].pointPadding = 0.3
                prepaid_obj.series[0].data.push(prepaid != 0 ? prepaid : null)
                prepaid_obj.series[0].color = 'rgba(0,160,130,1)'
                prepaid_obj.series[0].pointPadding = 0.3
                ontop_obj.series[0].data.push(ontop != 0 ? ontop : null)
                ontop_obj.series[0].color = 'rgba(210,0,0,1)'
                ontop_obj.series[0].pointPadding = 0.3
            }
        }//after loop
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            let postpaid_in_pie = total.postpaid
            let prepaid_in_pie = total.prepaid
            let ontop_in_pie = total.ontop
            pie_obj.series = [{
                name: 'จำนวนรายการส่งเสริมการขาย',
                colorByPoint: true,
                data: [{
                    name: 'Postpaid',
                    y: postpaid_in_pie,
                    sliced: false,
                    selected: false,
                    color: 'rgba(235,200,0,1)'
                }, {
                    name: 'Prepaid',
                    y: prepaid_in_pie,
                    color: 'rgba(0,160,130,1)'
                }, {
                    name: 'On-top',
                    y: ontop_in_pie,
                    color: 'rgba(2100,0,0,1)'
                }],
                showInLegend: true,
                allowPointSelect: true
            }]
            state.charts.push(pie_obj)
        }
    },
    BETWEEN_MONTH(state, obj){
        let date_start = obj.date.start
        let date_end = obj.date.end
        let month_start = moment(date_start).month()
        let month_end = moment(date_end).month()
        let year_start = moment(date_start).add(543,'y').year()
        let year_end = moment(date_end).add(543,'y').year()
        let group_month = groupMonth(obj.qrydata)
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        let list = obj.forminfo.list
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) เดือน"+month_th[month_start]+" ปี พ.ศ. "+year_start+" ถึงเดือน"+month_th[month_end]+" ปี พ.ศ. "+year_end
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) เดือน"+month_th[month_start]+" ปี พ.ศ. "+year_start+" ถึงเดือน"+month_th[month_end]+" ปี พ.ศ. "+year_end
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) เดือน"+month_th[month_start]+" ปี พ.ศ. "+year_start+" ถึงเดือน"+month_th[month_end]+" ปี พ.ศ. "+year_end
        let count = []
        for (let x = 0; x < list.length; x++) {
            let name = obj.forminfo.compare_type == 'group' ? 'กลุ่มผู้ให้บริการ ' + list[x].group_name_th : list[x].brand_name
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            postpaid_obj.xAxis.categories.push(name)
            prepaid_obj.xAxis.categories.push(name)
            ontop_obj.xAxis.categories.push(name)
            for (let month = 0, date = date_start, c = 0.25; date < date_end; month++, date = moment(date).add(1,'M'), c+=(0.75/(group_month.length-1))){
                let color_postpaid = 'rgba(235,200,0,' + c + ')'
                let color_prepaid = 'rgba(0,160,130,' + c + ')'
                let color_ontop = 'rgba(210,0,0,' + c + ')'
                let new_group = group_month.filter((month) => { return (moment(month.monthly_regulate).format('YYYY-MM-DD') == moment(date).format('YYYY-MM-DD')) })
                let rowdata = []
                if (new_group.length != 0) rowdata = new_group[0].data.filter(item => provider_id.includes(item.provider_id) && (item.end_service_date == null || moment(item.end_service_date).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')))
                
                let total =  {
                    prepaid : 0,
                    postpaid : 0,
                    ontop : 0
                }
                let prepaid = 0,
                postpaid = 0,
                ontop = 0
                for(let a=0;a<rowdata.length;a++){
                    if(moment(rowdata[a].monthly_regulate).year() < 2020){
                        postpaid += rowdata[a].postpaid
                        prepaid += rowdata[a].prepaid
                        ontop += rowdata[a].ontop
                        total.postpaid += rowdata[a].postpaid
                        total.prepaid += rowdata[a].prepaid
                        total.ontop += rowdata[a].ontop
                    }else{
                        if(rowdata[a].promotion_type == 'main'){
                            if(rowdata[a].promotion_category == 'prepaid'){
                                prepaid += rowdata[a].amount
                                total.prepaid += rowdata[a].amount
                            }else{//postpaid
                                postpaid += rowdata[a].amount
                                total.postpaid += rowdata[a].amount
                            }
                        }else{//ontop
                            ontop += rowdata[a].amount
                            total.ontop += rowdata[a].amount
                        }   
                    }
                }
                if(x == 0) {
                    let short_month = month_short_th[moment(date).month()] + ((parseInt(moment(date).add(543, 'Y').year())) - 2500)
                    postpaid_obj.series.push({
                        name: short_month,
                        data: [postpaid != 0 ? postpaid : null],
                        color: color_postpaid
                    })
                    prepaid_obj.series.push({
                        name: short_month,
                        data: [prepaid != 0 ? prepaid : null],
                        color: color_prepaid
                    })
                    ontop_obj.series.push({
                        name: short_month,
                        data: [ontop != 0 ? ontop : null],
                        color: color_ontop
                    })
                    count.push({
                        date: month_short_th[moment(date).month()] + moment(date).add(543, 'Y').format('YYYY'),
                        title: "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่" + obj.forminfo.provider_title + " เดือน"+month_th[moment(date).month()]+" ปี พ.ศ. " + moment(date).add(543, 'Y').format('YYYY'),
                        postpaid: postpaid,
                        color_postpaid: color_postpaid,
                        prepaid: prepaid,
                        color_prepaid: color_prepaid,
                        ontop: ontop,
                        color_ontop: color_ontop
                    })
                } else {
                    postpaid_obj.series[month].data.push(postpaid != 0 ? postpaid : null)
                    prepaid_obj.series[month].data.push(prepaid != 0 ? prepaid : null)
                    ontop_obj.series[month].data.push(ontop != 0 ? ontop : null)
                    count[month].postpaid += postpaid
                    count[month].prepaid += prepaid
                    count[month].ontop += ontop
                }
            }
        }
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            for (let i = 0; i < count.length; i++) {
                let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
                let postpaid_in_pie = !isNaN(count[i].postpaid) ? count[i].postpaid : 0
                let prepaid_in_pie = !isNaN(count[i].prepaid) ? count[i].prepaid : 0
                let ontop_in_pie = !isNaN(count[i].ontop) ? count[i].ontop : 0
                let color_postpaid = 'rgba(235,200,0,1)'
                let color_prepaid = 'rgba(0,160,130,1)'
                let color_ontop = 'rgba(210,0,0,1)'
                pie_obj.title.text = count[i].title
                if ((postpaid_in_pie + prepaid_in_pie + ontop_in_pie) > 0) {
                    pie_obj.series = [{
                        name: 'จำนวนรายการส่งเสริมการขาย',
                        colorByPoint: false,
                        data: [{
                            name: 'Postpaid',
                            y: postpaid_in_pie,
                            sliced: false,
                            selected: false,
                            color: color_postpaid
                        }, {
                            name: 'Prepaid',
                            y: prepaid_in_pie,
                            color: color_prepaid
                        }, {
                            name: 'On-top',
                            y: ontop_in_pie,
                            color: color_ontop
                        }],
                        showInLegend: true,
                        allowPointSelect: true
                    }]
                } else {
                    pie_obj.series = [{
                        type: 'pie',
                        data: []
                    }]
                    pie_obj.noData = {
                        style: {
                            fontWeight: 'bold',
                            fontSize: '15px',
                            color: '#303030'
                        }
                    }
                }
                state.charts.push(pie_obj)
            }
        }
    },
    YEAR(state,obj){
        let date_start = obj.date.start
        let year_start = moment(date_start).add(543,'y').year()
        let group_year = groupYear(obj.qrydata)
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        let list = obj.forminfo.list
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) ปี พ.ศ. "+year_start
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) ปี พ.ศ. "+year_start
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) ปี พ.ศ. "+year_start
        let count = []
        for (let x = 0; x < list.length; x++) {
            let name = obj.forminfo.compare_type == 'group' ? list[x].group_name_th : list[x].brand_name
            let color = obj.forminfo.compare_type == 'group' ? list[x].group_color_code : list[x].provider_color
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            postpaid_obj.xAxis.categories.push(name)
            prepaid_obj.xAxis.categories.push(name)
            ontop_obj.xAxis.categories.push(name)
            for (let year = 0, date = date_start, c = 1; year < group_year.length; year++, date = moment(date).add(1,'y')){
                let color_postpaid = 'rgba(235,200,0,' + c + ')'
                let color_prepaid = 'rgba(0,160,130,' + c + ')'
                let color_ontop = 'rgba(210,0,0,' + c + ')'
                let rowdata = group_year[year].data.filter(item => provider_id.includes(item.provider_id))
                let total =  {
                    prepaid : 0,
                    postpaid : 0,
                    ontop : 0
                }
                let prepaid = 0,
                postpaid = 0,
                ontop = 0
                for(let a=0;a<rowdata.length;a++){
                    if(moment(rowdata[a].monthly_regulate).year() < 2020){
                        postpaid += rowdata[a].postpaid
                        prepaid += rowdata[a].prepaid
                        ontop += rowdata[a].ontop
                        total.postpaid += rowdata[a].postpaid
                        total.prepaid += rowdata[a].prepaid
                        total.ontop += rowdata[a].ontop
                    }else{
                        if(rowdata[a].promotion_type == 'main'){
                            if(rowdata[a].promotion_category == 'prepaid'){
                                prepaid = rowdata[a].amount
                                total.prepaid = rowdata[a].amount
                            }else{//postpaid
                                postpaid = rowdata[a].amount
                                total.postpaid = rowdata[a].amount
                            }
                        }else{//ontop
                            ontop = rowdata[a].amount
                            total.ontop = rowdata[a].amount
                        }   
                    }
                }
                if(x == 0) {
                    postpaid_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [postpaid != 0 ? postpaid : null],
                        color: color_postpaid,
                        pointPadding: 0.3
                    })
                    prepaid_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [prepaid != 0 ? prepaid : null],
                        color: color_prepaid,
                        pointPadding: 0.3
                    })
                    ontop_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [ontop != 0 ? ontop : null],
                        color: color_ontop,
                        pointPadding: 0.3
                    })
                    count.push({
                        date: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        title: "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่" + obj.forminfo.provider_title + " ปี พ.ศ. " + moment(date).add(543, 'Y').format('YYYY'),
                        postpaid: postpaid,
                        color_postpaid: color_postpaid,
                        prepaid: prepaid,
                        color_prepaid: color_prepaid,
                        ontop: ontop,
                        color_ontop: color_ontop
                    })
                } else {
                    postpaid_obj.series[year].data.push(postpaid != 0 ? postpaid : null)
                    prepaid_obj.series[year].data.push(prepaid != 0 ? prepaid : null)
                    ontop_obj.series[year].data.push(ontop != 0 ? ontop : null)
                    count[year].postpaid += postpaid
                    count[year].prepaid += prepaid
                    count[year].ontop += ontop
                }
            }
        }
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            for (let i = 0; i < count.length; i++) {
                let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
                let postpaid_in_pie = !isNaN(count[i].postpaid) ? count[i].postpaid : 0
                let prepaid_in_pie = !isNaN(count[i].prepaid) ? count[i].prepaid : 0
                let ontop_in_pie = !isNaN(count[i].ontop) ? count[i].ontop : 0
                let color_postpaid = 'rgba(235,200,0,1)'
                let color_prepaid = 'rgba(0,160,130,1)'
                let color_ontop = 'rgba(210,0,0,1)'
                pie_obj.title.text = count[i].title
                pie_obj.series = [{
                    name: 'จำนวนรายการส่งเสริมการขาย',
                    colorByPoint: true,
                    data: [{
                        name: 'Postpaid',
                        y: postpaid_in_pie,
                        sliced: false,
                        selected: false,
                        color: color_postpaid
                    }, {
                        name: 'Prepaid',
                        y: prepaid_in_pie,
                        color: color_prepaid
                    }, {
                        name: 'On-top',
                        y: ontop_in_pie,
                        color: color_ontop
                    }],
                    showInLegend: true,
                    allowPointSelect: true
                }]

                state.charts.push(pie_obj)
            }
        }
    },
    BETWEEN_YEAR(state,obj){
        let date_start = obj.date.start
        let date_end = obj.date.end
        let year_start = moment(date_start).add(543,'y').year()
        let year_end = moment(date_end).add(543,'y').year()
        let group_year = groupYear(obj.qrydata)
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        let list = obj.forminfo.list
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) ระหว่างปี พ.ศ. "+year_start+" ถึงปี พ.ศ. "+year_end
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) ระหว่างปี พ.ศ. "+year_start+" ถึงปี พ.ศ. "+year_end
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) ระหว่างปี พ.ศ. "+year_start+" ถึงปี พ.ศ. "+year_end
        let count = []
        for (let x = 0; x < list.length; x++) {
            let name = obj.forminfo.compare_type == 'group' ? list[x].group_name_th : list[x].brand_name
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            postpaid_obj.xAxis.categories.push(name)
            prepaid_obj.xAxis.categories.push(name)
            ontop_obj.xAxis.categories.push(name)
            for (let year = 0, date = date_start, c = 0.25; /*year < group_year.length*/ date < date_end; year++, date = moment(date).add(1,'y'), c += (0.75/(group_year.length-1))){
                let color_postpaid = 'rgba(235,200,0,' + c + ')'
                let color_prepaid = 'rgba(0,160,130,' + c + ')'
                let color_ontop = 'rgba(210,0,0,' + c + ')'
                let new_group = group_year.filter((month) => { return (moment(month.monthly_regulate).isBetween(moment(date).format('YYYY-MM-DD'), moment(date).add(1, 'y').subtract(1, 'd').format('YYYY-MM-DD'), null, '[]')) })
                let rowdata = []
                if (new_group.length != 0) rowdata = new_group[0].data.filter(item => provider_id.includes(item.provider_id))
                let total =  {
                    prepaid : 0,
                    postpaid : 0,
                    ontop : 0
                }
                let prepaid = 0,
                postpaid = 0,
                ontop = 0
                for(let a=0;a<rowdata.length;a++){
                    if(moment(rowdata[a].monthly_regulate).year() < 2020){
                        postpaid += rowdata[a].postpaid
                        prepaid += rowdata[a].prepaid
                        ontop += rowdata[a].ontop
                        total.postpaid += rowdata[a].postpaid
                        total.prepaid += rowdata[a].prepaid
                        total.ontop += rowdata[a].ontop
                    }else{
                        if(rowdata[a].promotion_type == 'main'){
                            if(rowdata[a].promotion_category == 'prepaid'){
                                prepaid = rowdata[a].amount
                                total.prepaid = rowdata[a].amount
                            }else{//postpaid
                                postpaid = rowdata[a].amount
                                total.postpaid = rowdata[a].amount
                            }
                        }else{//ontop
                            ontop = rowdata[a].amount
                            total.ontop = rowdata[a].amount
                        }   
                    }
                }
                if(x == 0) {
                    postpaid_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [postpaid != 0 ? postpaid : null],
                        color: color_postpaid
                    })
                    prepaid_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [prepaid != 0 ? prepaid : null],
                        color: color_prepaid
                    })
                    ontop_obj.series.push({
                        name: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [ontop != 0 ? ontop : null],
                        color: color_ontop
                    })
                    count.push({
                        date: 'ปี ' + moment(date).add(543, 'Y').format('YYYY'),
                        title: "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่ ปี พ.ศ. " + moment(date).add(543, 'Y').format('YYYY'),
                        postpaid: postpaid,
                        color_postpaid: color_postpaid,
                        prepaid: prepaid,
                        color_prepaid: color_prepaid,
                        ontop: ontop,
                        color_ontop: color_ontop
                    })
                } else {
                    postpaid_obj.series[year].data.push(postpaid != 0 ? postpaid : null)
                    prepaid_obj.series[year].data.push(prepaid != 0 ? prepaid : null)
                    ontop_obj.series[year].data.push(ontop != 0 ? ontop : null)
                    count[year].postpaid += postpaid
                    count[year].prepaid += prepaid
                    count[year].ontop += ontop
                }
            }
        }
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            for (let i = 0; i < count.length; i++) {
                let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
                let postpaid_in_pie = !isNaN(count[i].postpaid) ? count[i].postpaid : 0
                let prepaid_in_pie = !isNaN(count[i].prepaid) ? count[i].prepaid : 0
                let ontop_in_pie = !isNaN(count[i].ontop) ? count[i].ontop : 0
                let color_postpaid = 'rgba(235,200,0,1)'
                let color_prepaid = 'rgba(0,160,130,1)'
                let color_ontop = 'rgba(210,0,0,1)'
                pie_obj.title.text = count[i].title
                if(postpaid_in_pie+prepaid_in_pie+ontop_in_pie > 0) {
                    pie_obj.series = [{
                        name: 'จำนวนรายการส่งเสริมการขาย',
                        colorByPoint: true,
                        data: [{
                            name: 'Postpaid',
                            y: postpaid_in_pie,
                            sliced: false,
                            selected: false,
                            color: color_postpaid
                        }, {
                            name: 'Prepaid',
                            y: prepaid_in_pie,
                            color: color_prepaid
                        }, {
                            name: 'On-top',
                            y: ontop_in_pie,
                            color: color_ontop
                        }],
                        showInLegend: true,
                        allowPointSelect: true
                    }]
                } else {
                    pie_obj.series = [{
                        type: 'pie',
                        data: []
                    }]
                    pie_obj.noData = {
                        style: {
                            fontWeight: 'bold',
                            fontSize: '15px',
                            color: '#303030'
                        }
                    }
                }
                state.charts.push(pie_obj)
            }
        }
    },
    QUARTER(state,obj){
        let date_start = obj.date.start
        let date_end = obj.date.end
        let quarter_start = obj.forminfo.type_data.quarter
        let year_start = moment(date_start).add(543,'y').year()
        let group_month = groupQuarter(obj.qrydata)
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        let list = obj.forminfo.list
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start
        let count = []
        for (let x = 0; x < list.length; x++) {
            let name = obj.forminfo.compare_type == 'group' ? 'กลุ่มผู้ให้บริการ ' + list[x].group_name_th : list[x].brand_name
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            postpaid_obj.xAxis.categories.push(name)
            prepaid_obj.xAxis.categories.push(name)
            ontop_obj.xAxis.categories.push(name)
            for (let month = 0, date = date_start, c = 1; month < group_month.length; month++, date = moment(date).add(3,'M')){
                let color_postpaid = 'rgba(235,200,0,' + c + ')'
                let color_prepaid = 'rgba(0,160,130,' + c + ')'
                let color_ontop = 'rgba(210,0,0,' + c + ')'
                let rowdata = group_month[month].data.filter(item => provider_id.includes(item.provider_id))
                let total =  {
                    prepaid : 0,
                    postpaid : 0,
                    ontop : 0
                }
                let prepaid = 0,
                postpaid = 0,
                ontop = 0
                for(let a=0;a<rowdata.length;a++){
                    if(moment(rowdata[a].monthly_regulate).year() < 2020){
                        postpaid += rowdata[a].postpaid
                        prepaid += rowdata[a].prepaid
                        ontop += rowdata[a].ontop
                        total.postpaid += rowdata[a].postpaid
                        total.prepaid += rowdata[a].prepaid
                        total.ontop += rowdata[a].ontop
                    }else{
                        if(rowdata[a].promotion_type == 'main'){
                            if(rowdata[a].promotion_category == 'prepaid'){
                                prepaid = rowdata[a].amount
                                total.prepaid = rowdata[a].amount
                            }else{//postpaid
                                postpaid = rowdata[a].amount
                                total.postpaid = rowdata[a].amount
                            }
                        }else{//ontop
                            ontop += rowdata[a].amount
                            total.ontop += rowdata[a].amount
                        }   
                    }
                }
                if(x == 0) {
                    postpaid_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [postpaid != 0 ? postpaid : null],
                        color: color_postpaid,
                        pointPadding: 0.3
                    })
                    prepaid_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [prepaid != 0 ? prepaid : null],
                        color: color_prepaid,
                        pointPadding: 0.3
                    })
                    ontop_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [ontop != 0 ? ontop : null],
                        color: color_ontop,
                        pointPadding: 0.3
                    })
                    count.push({
                        date: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        title: "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่" + obj.forminfo.provider_title + " ในไตรมาสที่ "+moment(date).quarter()+" ปี พ.ศ. " + moment(date).add(543, 'Y').format('YYYY'),
                        postpaid: postpaid,
                        color_postpaid: color_postpaid,
                        prepaid: prepaid,
                        color_prepaid: color_prepaid,
                        ontop: ontop,
                        color_ontop: color_ontop
                    })
                } else {
                    postpaid_obj.series[month].data.push(postpaid != 0 ? postpaid : null)
                    prepaid_obj.series[month].data.push(prepaid != 0 ? prepaid : null)
                    ontop_obj.series[month].data.push(ontop != 0 ? ontop : null)
                    count[month].postpaid += postpaid
                    count[month].prepaid += prepaid
                    count[month].ontop += ontop
                }
            }
        }
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            for (let i = 0; i < count.length; i++) {
                let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
                let postpaid_in_pie = !isNaN(count[i].postpaid) ? count[i].postpaid : 0
                let prepaid_in_pie = !isNaN(count[i].prepaid) ? count[i].prepaid : 0
                let ontop_in_pie = !isNaN(count[i].ontop) ? count[i].ontop : 0
                let color_postpaid = 'rgba(235,200,0,1)'
                let color_prepaid = 'rgba(0,160,130,1)'
                let color_ontop = 'rgba(210,0,0,1)'
                pie_obj.title.text = count[i].title
                pie_obj.series = [{
                    name: 'จำนวนรายการส่งเสริมการขาย',
                    colorByPoint: true,
                    data: [{
                        name: 'Postpaid',
                        y: postpaid_in_pie,
                        sliced: false,
                        selected: false,
                        color: color_postpaid
                    }, {
                        name: 'Prepaid',
                        y: prepaid_in_pie,
                        color: color_prepaid
                    }, {
                        name: 'On-Top',
                        y: ontop_in_pie,
                        color: color_ontop
                    }],
                    showInLegend: true,
                    allowPointSelect: true
                }]
                state.charts.push(pie_obj)
            }
        }
    },
    BETWEEN_QUARTER(state,obj){
        let date_start = obj.date.start
        let date_end = obj.date.end
        let quarter_start = obj.forminfo.type_data.quarterfrom
        let quarter_end = obj.forminfo.type_data.quarterto
        let year_start = moment(date_start).add(543,'y').year()
        let year_end = moment(date_end).add(543,'y').year()
        let group_month = groupQuarter(obj.qrydata)
        let postpaid_obj = JSON.parse(JSON.stringify(state.prototype.postpaid))
        let prepaid_obj = JSON.parse(JSON.stringify(state.prototype.prepaid))
        let ontop_obj = JSON.parse(JSON.stringify(state.prototype.ontop))
        let list = obj.forminfo.list
        postpaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบรายเดือน (Postpaid) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start+" ถึงไตรมาสที่ "+quarter_end+" ปี พ.ศ. "+year_end
        prepaid_obj.title.text = "จำนวนรายการส่งเสริมการขายแบบเติมเงิน (Prepaid) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start+" ถึงไตรมาสที่ "+quarter_end+" ปี พ.ศ. "+year_end
        ontop_obj.title.text = "จำนวนรายการส่งเสริมการขายเสริม (On-top) ในไตรมาสที่ "+quarter_start+" ปี พ.ศ. "+year_start+" ถึงไตรมาสที่ "+quarter_end+" ปี พ.ศ. "+year_end
        let count = []
        for (let x = 0; x < list.length; x++) {
            let name = obj.forminfo.compare_type == 'group' ? 'กลุ่มผู้ให้บริการ ' + list[x].group_name_th : list[x].brand_name
            let provider_id = obj.forminfo.compare_type == 'group' ? JSON.parse(list[x].group_company_list) : [list[x].id]
            postpaid_obj.xAxis.categories.push(name)
            prepaid_obj.xAxis.categories.push(name)
            ontop_obj.xAxis.categories.push(name)
            for (let month = 0, date = date_start, c = 0.25; /*month < group_month.length*/ date < date_end; month++, date = moment(date).add(3,'M'), c += (0.75/group_month.length)){
                let color_postpaid = 'rgba(235,200,0,' + c + ')'
                let color_prepaid = 'rgba(0,160,130,' + c + ')'
                let color_ontop = 'rgba(210,0,0,' + c + ')'
                let new_group = group_month.filter((month) => { return moment(month.monthly_regulate).add(1, 'd').isBetween(moment(date), moment(date).add(3, 'M').subtract(1, 'd'), null, '[]') })
                let rowdata = []
                if (new_group.length != 0) rowdata = new_group[0].data.filter(item => provider_id.includes(item.provider_id))
                let total =  {
                    prepaid : 0,
                    postpaid : 0,
                    ontop : 0
                }
                let prepaid = 0,
                postpaid = 0,
                ontop = 0
                for(let a=0;a<rowdata.length;a++){
                    if(moment(rowdata[a].monthly_regulate).year() < 2020){
                        postpaid += rowdata[a].postpaid
                        prepaid += rowdata[a].prepaid
                        ontop += rowdata[a].ontop
                        total.postpaid += rowdata[a].postpaid
                        total.prepaid += rowdata[a].prepaid
                        total.ontop += rowdata[a].ontop
                    }else{
                        if(rowdata[a].promotion_type == 'main'){
                            if(rowdata[a].promotion_category == 'prepaid'){
                                prepaid = rowdata[a].amount
                                total.prepaid = rowdata[a].amount
                            }else{//postpaid
                                postpaid = rowdata[a].amount
                                total.postpaid = rowdata[a].amount
                            }
                        }else{//ontop
                            ontop = rowdata[a].amount
                            total.ontop = rowdata[a].amount
                        }   
                    }
                }
                if(x == 0) {
                    postpaid_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [postpaid != 0 ? postpaid : null],
                        color: color_postpaid
                    })
                    prepaid_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [prepaid != 0 ? prepaid : null],
                        color: color_prepaid
                    })
                    ontop_obj.series.push({
                        name: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        data: [ontop != 0 ? ontop : null],
                        color: color_ontop
                    })
                    count.push({
                        date: moment(date).quarter() + 'Q' + moment(date).add(543, 'Y').format('YYYY'),
                        title: "เปรียบเทียบสัดส่วนร้อยละของรายการส่งเสริมการขายของบริการโทรศัพท์เคลื่อนที่" + obj.forminfo.provider_title + " ในไตรมาสที่ "+moment(date).quarter()+" ปี พ.ศ. " + moment(date).add(543, 'Y').format('YYYY'),
                        postpaid: postpaid,
                        color_postpaid: color_postpaid,
                        prepaid: prepaid,
                        color_prepaid: color_prepaid,
                        ontop: ontop,
                        color_ontop: color_ontop
                    })
                } else {
                    postpaid_obj.series[month].data.push(postpaid != 0 ? postpaid : null)
                    prepaid_obj.series[month].data.push(prepaid != 0 ? prepaid : null)
                    ontop_obj.series[month].data.push(ontop != 0 ? ontop : null)
                    count[month].postpaid += postpaid
                    count[month].prepaid += prepaid
                    count[month].ontop += ontop
                }
            }
        }
        if(obj.forminfo.chart_type == 'column') {
            // postpaid_obj.exporting = {
            //     csv: {
            //         columnHeaderFormatter: function(item, key) {
            //             if (!item || item.coll == "xAxis") {
            //                 return 'ผู้ให้บริการ'
            //             } else {
            //                 return item.name;
            //             }
            //         }
            //     }
            // }
            state.charts.push(postpaid_obj)
            state.charts.push(prepaid_obj)
            state.charts.push(ontop_obj)
        } else {
            for (let i = 0; i < count.length; i++) {
                let pie_obj = JSON.parse(JSON.stringify(state.prototype.pie))
                let postpaid_in_pie = !isNaN(count[i].postpaid) ? count[i].postpaid : 0
                let prepaid_in_pie = !isNaN(count[i].prepaid) ? count[i].prepaid : 0
                let ontop_in_pie = !isNaN(count[i].ontop) ? count[i].ontop : 0
                let color_postpaid = 'rgba(235,200,0,1)'
                let color_prepaid = 'rgba(0,160,130,1)'
                let color_ontop = 'rgba(210,0,0,1)'
                pie_obj.title.text = count[i].title
                if(postpaid_in_pie+prepaid_in_pie+ontop_in_pie > 0) {
                    pie_obj.series = [{
                        name: 'จำนวนรายการส่งเสริมการขาย',
                        colorByPoint: true,
                        data: [{
                            name: 'Postpaid',
                            y: postpaid_in_pie,
                            sliced: false,
                            selected: false,
                            color: color_postpaid
                        }, {
                            name: 'Prepaid',
                            y: prepaid_in_pie,
                            color: color_prepaid
                        }, {
                            name: 'On-top',
                            y: ontop_in_pie,
                            color: color_ontop
                        }],
                        showInLegend: true,
                        allowPointSelect: true
                    }]
                } else {
                    pie_obj.series = [{
                        type: 'pie',
                        data: []
                    }]
                    pie_obj.noData = {
                        style: {
                            fontWeight: 'bold',
                            fontSize: '15px',
                            color: '#303030'
                        }
                    }
                }
                state.charts.push(pie_obj)
            }
        }
    },
    DISPLAY_CHART(state,status){
        state.displayCharts = status
        state.displayText = !status
    }
}
function formatNumber(num) {
    if (num >= 10) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    } else if( num < 1 ) {
      return num;
    }
    return num.toFixed(2);
}

function groupProvider(obj) {
    let r = []
    let group = []
    for (let i = 0; i < obj.length; i++) {
        r.includes(obj[i].provider_id) ? null : r.push(obj[i].provider_id)
        if(group[r.indexOf(obj[i].provider_id)] == undefined) {
            group.push({
                provider_id: obj[i].provider_id,
                data: [obj[i]]
            })
        } else {
            group[r.indexOf(obj[i].provider_id)].data.push(obj[i])
        }
    }
    return group
}

function groupMonth(obj) {
    let r = []
    let group = []
    for (let i = 0; i < obj.length; i++) {
        r.includes(obj[i].monthly_regulate) ? null : r.push(obj[i].monthly_regulate)
        if(group[r.indexOf(obj[i].monthly_regulate)] == undefined) {
            group.push({
                monthly_regulate: obj[i].monthly_regulate,
                data: [obj[i]]
            })
        } else {
            group[r.indexOf(obj[i].monthly_regulate)].data.push(obj[i])
        }
    }
    return group
}

function groupYear(obj) {
    let r = []
    let group = []
    for (let i = 0; i < obj.length; i ++) {
        r.includes(moment(obj[i].monthly_regulate).year()) ? null : r.push(moment(obj[i].monthly_regulate).year())
        if(group[r.indexOf(moment(obj[i].monthly_regulate).year())] == undefined) {
            group.push({
                monthly_regulate: moment(obj[i].monthly_regulate).format('YYYY-MM-DD'),
                data: [obj[i]]
            })
        } else {
            group[r.indexOf(moment(obj[i].monthly_regulate).year())].data.push(obj[i])
        }
    }
    return group
}

function groupQuarter(obj) {
    let r = []
    let group = []
    for (let i = 0; i < obj.length; i ++) {
        r.includes(moment(obj[i].monthly_regulate).quarter() + '-' + moment(obj[i].monthly_regulate).year()) ? null : r.push(moment(obj[i].monthly_regulate).quarter() + '-' + moment(obj[i].monthly_regulate).year())
        if(group[r.indexOf(moment(obj[i].monthly_regulate).quarter() + '-' + moment(obj[i].monthly_regulate).year())] == undefined) {
            group.push({
                monthly_regulate: obj[i].monthly_regulate,
                data: [obj[i]]
            })
        } else {
            group[r.indexOf(moment(obj[i].monthly_regulate).quarter() + '-' + moment(obj[i].monthly_regulate).year())].data.push(obj[i])
        }
    }
    return group
}

export const Report_pmt = {
  namespaced: true,
  state,
  actions,
  mutations
};
